import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "react-router-dom";
import { router } from "./routes";
import { Toaster } from "react-hot-toast";
import GlobalLogoutHandler from "@/components/auth/GlobalLogoutHandler";
import "./index.css";

import { Suspense } from "react";
import TranslationLoader from "@/components/ui/TranslationLoader";
import "./i18n";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
// import { UserProvider } from "@/context/UserProvider";
import { AuthProvider } from "@/context/AuthProvider";
import { LoadingProvider } from "@/context/LoadingProvider";

const queryClient = new QueryClient();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        {/* <UserProvider> */}
          <LoadingProvider>
          <Suspense fallback={<TranslationLoader />}>
              <RouterProvider router={router} />
            </Suspense>
          </LoadingProvider>
        {/* </UserProvider> */}
      </AuthProvider>
      <Toaster position="bottom-center" />
      <GlobalLogoutHandler />
    </QueryClientProvider>
  </StrictMode>
);
